import * as actionTypes from './actionTypes';
import { toastr } from 'react-redux-toastr'
import { fetchEquipmentsPublicByIdWithServicesReplicateService } from '../../services/equipmentsPublic';


export const fetchEquipmentByIdSuccess = (equipment) => {
  return {
    type: actionTypes.FETCH_EQUIPMENTS_PUBLIC_BY_ID_SUCCESS,
    equipment: equipment
  };
}

export const requestEquipmentsFail = (error) => {
  return {
    type: actionTypes.REQUEST_EQUIPMENTS_PUBLIC_FAIL,
    error: error
  };
};

export const requestEquipmentsStart = () => {
  return {
    type: actionTypes.REQUEST_EQUIPMENTS_PUBLIC_START
  };
};

export const fetchEquipmentsPublicByIdWithServicesReplicate = (id) => {

  return dispatch => {
    dispatch(requestEquipmentsStart());
    fetchEquipmentsPublicByIdWithServicesReplicateService(id)
      .then(res => {
        dispatch(fetchEquipmentByIdSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestEquipmentsFail(err));
      });
  };
};
